import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import SiteAnnouncementBanner from "./SiteAnnouncementBanner";

registerExtension("site.layout.header.below", SiteAnnouncementBanner, "SiteAnnouncementBanner");
